import { useQuery, skipToken } from '@tanstack/react-query';
import { fetchUnitCollectionData } from '../services/unitcollection/unit-collection';

export function useUnitCollectionData(unitId: string | undefined) {
  return useQuery({
    queryKey: ['fetchUnitCollectionData', unitId],
    queryFn: unitId ? () => fetchUnitCollectionData(unitId) : skipToken,
    staleTime: 90000,
  });
}
